'use strict';

/**
 * @name network
 */

exports.request = require('./request.js');
exports.sendSms = require('./send-sms.js');

//exports.httpRequest = require('./http-request.js'); // not support POST, disabled



//////////////////
// WEBPACK FOOTER
// ./~/@dp/knb/~/@hfe/hbnb/network/index.js
// module id = 603
// module chunks = 0